import React, { useEffect, useRef } from 'react'
import { Html5Qrcode, Html5QrcodeScanner, Html5QrcodeScanType, Html5QrcodeSupportedFormats } from 'html5-qrcode';

const Qrscancamera = ({ onScanSuccess }) => {
  const containerId = '"html5qr-code-full-region"';

  console.log('ss')

  const qrCodeRef = useRef(null)
  useEffect(() => {
    // The ID of the HTML element that will host the scanner

    if (!qrCodeRef.current) {
      qrCodeRef.current = new Html5Qrcode(containerId);
    }
    const html5Qrcode = qrCodeRef.current;

    const qrCodeConfig = {
      fps: 10, // Frames per second
      qrbox: { width: 250, height: 250 },
      rememberLastUsedCamera: true,
      showTorchButtonIfSupported: true,
      // Optional: specify facing mode, 'environment' for rear camera
      // facingMode: 'environment',
      supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]

    };



    const startScanning = async () => {
      try {
        // await html5Qrcode.start(
        //   { facingMode: "environment" },
        //   qrCodeConfig,
        //   (decodedText, decodedResult) => {
        //     // Success callback: This function is called AUTOMATICALLY when a QR code is detected.
        //     console.log(`Scan successful: ${decodedText}`, decodedResult);
        //     onScanSuccess(decodedText);
        //     // Stop scanning after a successful capture
        //     html5Qrcode.stop().catch(err => console.error("Failed to stop scanner", err));
        //   },
        //   (errorMessage) => {
        //     // Error callback (called frequently, can be ignored for simple auto-capture)
        //     // console.log(`QR scan error: ${errorMessage}`);
        //   }
        // );




        const html5QrcodeScanner = new Html5QrcodeScanner(
          containerId,
          qrCodeConfig,
  /* verbose= */ false);

        await html5QrcodeScanner.render(onScanSuccess);
        // html5QrcodeScanner.clear().then(_ => {
        //   // Optional: actions to perform after the UI is cleared
        //   console.log("QR Code scanning stopped and UI cleared.");
        // }).catch(error => {
        //   // Handle potential failure in stopping the scanner
        //   console.error("Failed to stop scanning:", error);
        // })
        
      } catch (err) {
        console.error("Unable to start scanning:", err);
      }
    };

    startScanning();

    // Cleanup function to stop the scanner when the component unmounts
    // return () => {
    //   if (html5Qrcode && html5Qrcode.is scanning) {
    //     html5Qrcode.stop().catch(err => console.error("Failed to stop scanner on unmount", err));
    //   }
    // };
  }, [onScanSuccess])

  return <div id={containerId} style={{ width: "100%", maxWidth: "400px" }} />



  return (
    <div>Qrscancamera</div>
  )
}

export default Qrscancamera